export default "__VITE_ASSET__DqCmy0MC__"